import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutUs from "./pages/about-us";
import Home from "./pages/home";
import OurTeam from "./pages/our-team";
import Values from "./pages/values";
import Blogs from "./pages/Blogs";
import BlogDetailPage from "./pages/Blogs/blogDetail";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/our-team" element={<OurTeam />} />
         <Route path="/values" element={<Values />} />
         <Route path="/blogs" element={<Blogs />} />
           <Route path="/blogsDetail" element={<BlogDetailPage />} />

      </Routes>
    </Router>
  );
};

export default App;
